<article class="job-card">
  <a class="card-link" [routerLink]="['/jobs', job.id]" [attr.aria-label]="'Open job ' + (job.address || job.id)">
    <div class="card-title-row">
      <h3>{{ job.address || 'No Address' }}</h3>
      <span class="status-pill" [ngClass]="statusClass(job.status)">{{ job.status || 'Pending' }}</span>
    </div>
    <p class="job-number">{{ job.jobNumber ? 'TOPS Job #' + job.jobNumber : 'New Job' }}</p>
    <p class="report-type">{{ job.reportType || 'No report type selected' }}</p>
    <div class="meta-row">
      <span class="date-meta"><span class="calendar-icon" aria-hidden="true"></span>{{ formatDate(job.appointmentDate) }}</span>
      <span class="time-meta"><span class="clock-icon" aria-hidden="true"></span>{{ job.appointmentTime || 'TBD' }}</span>
    </div>
    @if (photoUrl(job.photoUrl); as source) {
      <img [src]="source" alt="Property view" />
    }
  </a>

  <div class="card-actions">
    <button type="button" class="menu-trigger" aria-label="Job actions">
      <span aria-hidden="true"></span>
    </button>
    <div class="action-menu" role="menu">
      <button type="button" role="menuitem" (click)="runAction($event, 'edit')">Edit</button>
      <button type="button" role="menuitem" (click)="runAction($event, 'markCompleted')">Mark Completed</button>
      <button type="button" role="menuitem" (click)="runAction($event, 'archive')">Archive</button>
      <button type="button" role="menuitem" class="delete-action" (click)="runAction($event, 'delete')">Delete</button>
    </div>
  </div>
</article>
